import React from 'react';
import './styles.css';
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";

const Footer = () => {
  const handleClick = (label) => {
    switch (label) {
      case 'Privacy Policy':
        window.location.href = '/privacy-policy';
        break;
      case 'Terms of Service':
      case 'Terms':
        window.location.href = '/terms-of-service';
        break;
      case 'FAQ':
        window.location.href = '/faq';
        break;
      case 'Contact':
        window.location.href = '/contact';
        break;
      case 'Safety Tips':
        window.location.href = '/safety-tips';
        break;

      case 'App Store':
      case 'Google Play':
        window.open('https://play.google.com/store/apps/details?id=com.consolelog.poolparty', '_blank');
        break;

      default:
        console.log(`${label} clicked, but no URL defined.`);
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-columns">
        <div className="footer-section">
          <h4>Legal</h4>
          <p onClick={() => handleClick('Privacy Policy')}>Privacy Policy</p>
          <p onClick={() => handleClick('Terms of Service')}>Terms of Service</p>
        </div>

        <div className="footer-section">
          <h4>Help</h4>
          <p onClick={() => handleClick('FAQ')}>FAQ</p>
          <p onClick={() => handleClick('Contact')}>Contact</p>
          <p onClick={() => handleClick('Safety Tips')}>Safety Tips</p>
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-app-row">
        <h2>Get the app!</h2>
        <div className="footer-app-buttons">
          <GooglePlayButton url={'https://play.google.com/store/apps/details?id=com.consolelog.poolparty'} theme={"dark"} className={"custom-google-play-button"} />
          {/* iOS coming soon
          <AppStoreButton url={'#'} theme={"dark"} className={'custom-apple-button'} />
          */}
        </div>
      </div>

      <div className="footer-marketing">
        <p>
          Looking for a fresh way to meet people? Pool Party Social Club is a new take on social connection that focuses on live video chat and spontaneous interaction. No endless scrolling, no ghosting—just real conversations with real people nearby. Whether you're looking for new friends, interesting conversations, or just want to expand your social circle, Pool Party is the human-centered social experience you've been waiting for.
        </p>
        <p>
          Pool Party Social Club helps you connect instantly through face-to-face video, making socializing more authentic and less awkward. Perfect for introverts, extroverts, college students, travelers, or anyone tired of shallow social media interactions. We're here to make real-time connections the new normal.
        </p>
        <p>
          Discover meaningful friendships, spontaneous chats, and unexpected connections—all through one simple, beautifully designed app. Join Pool Party Social Club today and see why it's becoming the go-to app for authentic social connection. The future of meeting people is real, raw, and right in your city.
        </p>
      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom-row">
        <div className="footer-bottom-links">
          <span onClick={() => handleClick('FAQ')}>FAQ</span>
          <span className="divider">/</span>
          <span onClick={() => handleClick('Safety Tips')}>Safety Tips</span>
          <span className="divider">/</span>
          <span onClick={() => handleClick('Terms')}>Terms</span>
        </div>
        <div className="footer-bottom-right">
          © 2026 console.log LLC, All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
